import { envConfig } from "config/envConfig"
import { useAuth } from "modules/auth/Auth"
import { useFlag } from "modules/flags/flags"
import { ComponentProps } from "react"
import { useGitbookToken } from "services/users"
import { cn } from "styles/cn"

export { HelpEmbed, HelpPage }

function HelpEmbed({ className, ...props }: ComponentProps<"iframe">) {
	const { helpDocsEmbed } = useFlag("helpDocsEmbed")
	const { isSignedIn } = useAuth()
	const { data } = useGitbookToken(isSignedIn)
	const src = `${envConfig.gitbookUrl()}?jwt_token=${data}`

	console.debug("Help documentation", {
		["User authenticated"]: isSignedIn,
		["Gitbook token generated by RHL API"]: data,
	})

	if (!helpDocsEmbed.enabled) {
		return null
	}

	return (
		<iframe
			{...props}
			title="GitBook"
			src={src}
			width="100%"
			height="100%"
			className={cn("h-full overflow-auto", className)}
		/>
	)
}

function HelpPage() {
	return <HelpEmbed className="h-svh" />
}
